import { render, staticRenderFns } from "./ScoringFormula.vue?vue&type=template&id=5c9a8be6&"
import script from "./ScoringFormula.vue?vue&type=script&lang=js&"
export * from "./ScoringFormula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports